import React, { Fragment } from 'react';
import RadioGroupField from '../../RadioGroupField';
import { emptyNotEmpty, radioOptionButtons } from '../attribute-utils';
import FilterContainerMenuItem from './FilterContainerMenuItem';

const FilterContainerMenu = (props) => {
  const {
      filterAttributes,
      enums,
      state,
      onChangeFirstCriteria,
      onChangeFirstComboBox,
      onChangeFirstDate,
      onChangeFirstInput,
      onChangeFirstInputRange,
      radioButtons,
      onChangeRadioOption,
      onChangeSecondCriteria,
      onChangeSecondComboBox,
      onChangeSecondDate,
      onChangeSecondInput,
      onChangeSecondInputRange,
      t,
    } = props || {},
    {
      attribute,
      firstCriteria,
      firstInput,
      firstInputRange,
      radioOption,
      secondCriteria,
      secondInput,
      secondInputRange,
    } = state || {};

  const showSecondFilter =
    firstInput || emptyNotEmpty(enums, firstCriteria) ? 'block' : 'none';

  return (
    <Fragment>
      <FilterContainerMenuItem
        attribute={attribute}
        filterAttributes={filterAttributes}
        enums={enums}
        criteria={firstCriteria}
        input={firstInput}
        inputRange={firstInputRange}
        onChangeCriteria={onChangeFirstCriteria}
        onChangeComboBox={onChangeFirstComboBox}
        onChangeDate={onChangeFirstDate}
        onChangeInput={onChangeFirstInput}
        onChangeInputRange={onChangeFirstInputRange}
        t={t}
      />
      <div
        className="block-filter-second radio-group"
        style={{
          display: showSecondFilter,
        }}
      >
        <RadioGroupField
          classNameRadio="radio-group"
          data={radioOptionButtons(radioButtons)}
          value={radioOption}
          onChange={onChangeRadioOption}
          row
        />
        <FilterContainerMenuItem
          attribute={attribute}
          filterAttributes={filterAttributes}
          enums={enums}
          criteria={secondCriteria}
          input={secondInput}
          inputRange={secondInputRange}
          onChangeCriteria={onChangeSecondCriteria}
          onChangeComboBox={onChangeSecondComboBox}
          onChangeDate={onChangeSecondDate}
          onChangeInput={onChangeSecondInput}
          onChangeInputRange={onChangeSecondInputRange}
          t={t}
        />
      </div>
    </Fragment>
  );
};

export default FilterContainerMenu;
